//@flow
import {
  HSET,
  HSETNX,
  HMSET,
  HINCRBY,
  HTOGGLE,
  HDEL,
  HDELALL
} from './actionTypes'
import type {
  SetAction,
  MultipleSetAction,
  IncrementByAction,
  ToggleAction,
  DelKeysAction,
  DelAllKeysAction
} from './types'
import invariant from 'invariant'

/**
 * Sets a single value in a hash, specified by
 * domain and key
 * @param {String} domain
 * @param {String} keyPath
 * @param {any} value
 * @return {Object}
 */
export function hset(domain: string, keyPath: string, value: any): SetAction {
  return {
    type: HSET,
    payload: {
      path: [domain, keyPath].join('.'),
      value
    }
  }
}

/**
 * Sets a single value in a hash, ONLY if the key does not exist
 * @param {String} domain
 * @param {String} keyPath
 * @param {any} value
 */
export function hsetnx(domain: string, keyPath: string, value: any): SetAction {
  return {
    type: HSETNX,
    payload: {
      path: [domain, keyPath].join('.'),
      value
    }
  }
}

/**
 * Merges a Javascript object in an existing hash
 * @param {String} domain
 * @param {Object} map
 * @return {Object}
 */
export function hmset(domain: string, map: Object): MultipleSetAction {
  return {
    type: HMSET,
    payload: {
      path: domain,
      value: map
    }
  }
}

export function hincrby(
  domain: string,
  key: string,
  delta: number = 1
): IncrementByAction {
  return {
    type: HINCRBY,
    payload: {
      path: [domain, key].join('.'),
      value: delta
    }
  }
}

/*
Toggles a Boolean key in a hash. If key is not present, it will assumed to
be false, so htoggle() will cause it to be true.
*/
export function htoggle(domain: string, key: string): ToggleAction {
  return {
    type: HTOGGLE,
    payload: {
      path: [domain, key].join('.')
    }
  }
}

/* Removes one or more keys in a hash */
export function hdel(domain: string, ...keys: Array<string>): DelKeysAction {
  invariant(
    Array.isArray(keys) && keys.length,
    'hdel expects one or more keys as strings to remove from the hash. To remove all keys, use hdelAll(domain)'
  )
  return {
    type: HDEL,
    payload: {
      path: domain,
      keys
    }
  }
}

/* Removes all keys under domain */
export function hdelAll(domain: string): DelAllKeysAction {
  return {
    type: HDELALL,
    payload: {
      path: domain
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/hash/actions.js